<template>
<section class="radio-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <van-radio-group v-model="radio" class="radio-f" icon-size="16px" checked-color="#e1303a">
        <!-- <van-radio name="1" class="radio-s">单选框 1</van-radio>
        <van-radio name="2">单选框 2</van-radio> -->
        <van-radio v-for="item in transProp.choices" :name="item.value">{{item.value}}</van-radio>
    </van-radio-group>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
</section>
</template>

<script>
import { RadioGroup, Radio, Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-icon": Icon
  },
  data() {
    return {
      radio: null,
      showError: false
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.radio
      };
      return options;
    },
    validate() {
      if (this.transProp.required) {
        if (!this.radio) {
          this.showError = true;

          return { label: this.transProp.label, boo: true };
        } else {
          this.showError = false;
          return { label: this.transProp.label, boo: false };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .radio-s {
    margin-bottom: 10px;
  }
}
</style>
